import React, { useState, useRef } from 'react';
import { useEffect } from 'react';
import {
	Row,
	Col,
	Container,
	Card,
	Accordion,
	Form,
	Table,
	Button,
	Alert,
	Modal,
} from 'react-bootstrap';
import ReactTable from 'react-table';
import requester from '../../lib/requester';
import _ from 'lodash';

function ApprovalSalesTarget() {
	const [data, setData] = useState([]);
	const [showModalConfirmApprove, setShowModalConfirmApprove] = useState(false);
	const [showModalConfirmReject, setShowModalConfirmReject] = useState(false);
	const [disableButtonApprove, setDisableButtonApprove] = useState(false);
	const [disableButtonReject, setDisableButtonReject] = useState(false);

	useEffect(() => {
		init();
	}, []);

	const init = async () => {
		requester.getCHD('/api/traces_chd/v1/upload/get-sales-target', {
			success: (res) => {
				// ! add from fahron
				// 
				let data = [];
				//console.log(res.data.data);
				for (let i of res.data.data) {
					if (i.org_id == JSON.parse(window.localStorage.getItem('is_user'))["org_id"]) {
						data.push(i);
					}
				}
				setData(data);
				// ! end add from fahron
			},
			error: (err) => {
				console.log(err);
			},
		});
	};

	const approve = () => {
		const checkedData = getCheckedData();
		if (checkedData.length <= 0) {
			alert('Please select at least one row!');
			return;
		}
		requester.postCHD(
			'/api/traces_chd/v1/upload/approval-sales-target',
			{
				type: 'APPROVED',
				data: checkedData,
			},
			{
				success: () => window.location.reload(),
				error: (e) => alert(e.toString()),
			}
		);
	};

	const reject = () => {
		const checkedData = getCheckedData();
		if (checkedData.length <= 0) {
			alert('Please select at least one row!');
			return;
		}
		requester.postCHD(
			'/api/traces_chd/v1/upload/approval-sales-target',
			{
				type: 'REJECTED',
				data: checkedData,
			},
			{
				success: () => window.location.reload(),
				error: (e) => alert(e.toString()),
			}
		);
		console.log('reject');
	};

	const renderModalConfirmApprove = () => (
		<Modal
			centered
			show={showModalConfirmApprove}
			onHide={() => setShowModalConfirmApprove(false)}>
			<Modal.Header closeButton>
				<Modal.Title>Approve Sales Target</Modal.Title>
			</Modal.Header>
			<Modal.Body>Are you sure?</Modal.Body>
			<Modal.Footer>
				<Button
					variant='secondary'
					onClick={() => setShowModalConfirmApprove(false)}>
					Cancel
				</Button>
				<Button
					disabled={disableButtonApprove}
					variant='primary'
					onClick={() => approve()}>
					Yes, Approve!
				</Button>
			</Modal.Footer>
		</Modal>
	);

	const getCheckedData = () => {
		return data.filter((obj) => obj.is_checked == 1);
	};

	const renderModalConfirmReject = () => (
		<Modal
			centered
			show={showModalConfirmReject}
			onHide={() => setShowModalConfirmReject(false)}>
			<Modal.Header closeButton>
				<Modal.Title>Reject Sales Target</Modal.Title>
			</Modal.Header>
			<Modal.Body>Are you sure?</Modal.Body>
			<Modal.Footer>
				<Button
					variant='secondary'
					onClick={() => setShowModalConfirmReject(false)}>
					Cancel
				</Button>
				<Button
					disabled={disableButtonReject}
					variant='danger'
					onClick={() => reject()}>
					Yes, Reject!
				</Button>
			</Modal.Footer>
		</Modal>
	);

	const columns = [
		{
			Header: '',
			width: 30,
			className: 'text-center',
			Cell: function (row) {
				const rowData = row.original;
				const index = row.index;
				return (
					<input
						type='checkbox'
						onChange={(e) => {
							const arrTemp = [...data];
							arrTemp[index].is_checked = e.target.checked ? 1 : 0;
							setData(arrTemp);
						}}
						checked={rowData.is_checked == 0 ? false : true}
					/>
				);
			},
		},
		{
			Header: 'CUSTOMER ID',
			accessor: 'customer_id',
		},
		{
			Header: 'CUSTOMER NAME',
			accessor: 'customer_name',
		},
		{
			Header: 'BRANCH ID',
			accessor: 'branch_id',
		},
		{
			Header: 'CLASS',
			accessor: 'class',
		},
		{
			Header: 'PROGRAM NAME',
			accessor: 'program_name',
		},
		{
			Header: 'QUARTER',
			accessor: 'quarter',
		},
		{
			Header: 'BRAND CHD',
			accessor: 'brand_chd',
		},
		{
			Header: 'SUB ACCOUNT',
			accessor: 'sub_account',
		},
		{
			Header: 'TARGET',
			accessor: 'target_value',
		},
	];

	return (
		<Container>
			<Row>
				<Col>
					<Card>
						<Card.Header style={{ backgroundColor: 'rgba(0,0,0,0.03)' }}>
							Approve Sales Target
						</Card.Header>
						<Card.Body>
							<Row>
								<Col>
									<ReactTable
										className='fullWidth'
										data={data}
										columns={columns}
										defaultPageSize={10}
									/>
								</Col>
							</Row>
							<Row className='mt-4'>
								<Col>
									<Button
										onClick={() => setShowModalConfirmApprove(true)}
										block
										variant='success'>
										APPROVE
									</Button>
								</Col>
								<Col>
									<Button
										onClick={() => setShowModalConfirmReject(true)}
										block
										variant='danger'>
										REJECT
									</Button>
								</Col>
							</Row>
						</Card.Body>
					</Card>
				</Col>
			</Row>
			{renderModalConfirmApprove()}
			{renderModalConfirmReject()}
		</Container>
	);
}

export default ApprovalSalesTarget;
